function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

import _styled from "@emotion/styled/base";

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from 'react';
import { Collapsable } from '../Collapsable';
import { NavigationLink } from '../NavigationLink';
import { normalizeLocationPath } from '../../documentation-layout/normalizeLocationPath';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

var Wrapper = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e16qk55l0"
} : {
  target: "e16qk55l0",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "kjfeme",
  styles: "position:relative;display:flex;flex-flow:row nowrap;align-items:center"
} : {
  name: "kjfeme",
  styles: "position:relative;display:flex;flex-flow:row nowrap;align-items:center",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var MidLevelNavigationItem = /*#__PURE__*/function (_React$Component) {
  _inherits(MidLevelNavigationItem, _React$Component);

  var _super = _createSuper(MidLevelNavigationItem);

  function MidLevelNavigationItem(props) {
    var _this;

    _classCallCheck(this, MidLevelNavigationItem);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getActiveProps", function (currentLocation, href) {
      var _normalizeLocationPat = normalizeLocationPath(currentLocation),
          normalizedPathName = _normalizeLocationPat.path;

      if ("".concat(normalizedPathName) === href) {
        return 'active';
      }

      return '';
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (delta, collpasableElement) {
      _this.props.onChange(delta, collpasableElement, _this.triggerRef.current);
    });

    _this.triggerRef = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(MidLevelNavigationItem, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          title = _this$props.title,
          path = _this$props.path,
          location = _this$props.location;
      return _jsx(Collapsable, {
        id: "collapsable".concat(this.props.path).concat(this.props.title),
        onChange: this.handleOnChange,
        trigger: function trigger(unfold, folded) {
          return _jsx(Wrapper, {
            onClick: function onClick() {
              return unfold();
            },
            children: _jsx(NavigationLink, {
              ref: _this2.triggerRef,
              to: path,
              className: _this2.getActiveProps(location, path),
              children: title
            })
          });
        },
        children: _jsx("div", {
          style: {
            marginLeft: '1rem',
            width: 'calc(100% - 1rem)'
          },
          children: this.props.children
        })
      });
    }
  }]);

  return MidLevelNavigationItem;
}(React.Component);

export { MidLevelNavigationItem };